import { UnitWithTransmissionStatus } from 'src/app/units/models/unit-transmission-status';
import {
  TransmissionState,
  TransmissionStateGroup,
} from '../models/transmission-state-group';

export function groupVehiclesByTransmissionState(
  units: UnitWithTransmissionStatus[]
): TransmissionStateGroup[] {
  const mapStates = new Map<TransmissionState, number>();

  // Inicializamos los 6 estados con 0
  Object.values(TransmissionState)
    .filter((v) => typeof v === 'number') // por el reverse mapping de enums numéricos
    .forEach((stateId) => {
      mapStates.set(stateId as TransmissionState, 0);
    });

  // Sumamos los estados que aparecen en las units
  units.forEach((unit) => {
    const current = mapStates.get(unit.transmissionStatusId) ?? 0;
    mapStates.set(unit.transmissionStatusId, current + 1);
  });

  // Devolvemos el array con el formato esperado
  return Array.from(mapStates.entries()).map(
    ([transmissionStateId, count]) => ({
      transmissionStatusId: transmissionStateId,
      quantityVehicle: count,
    })
  );
}
